// API Configuration
const API_CONFIG = {
  baseUrl: process.env.VUE_APP_BASE_URL,
  endpoints: {
    validateFiles: '/extract-attribute/files/validate'
  }
}

// Get full API URL for an endpoint
const getApiUrl = (endpoint) => {
  return `${API_CONFIG.baseUrl}${endpoint}`
}

// Export configuration
export {
  API_CONFIG,
  getApiUrl
} 